export default "__VITE_ASSET__a5oenKJO__"